import Vue from "vue";
import { isMobile, isIOS, isAndroid } from "mobile-device-detect";

Vue.mixin({
  computed: {
    _isMobile() {
      return isMobile;
    },
    _isIOS() {
      return isIOS;
    },
    _isAndroid() {
      return isAndroid;
    },
    _isDesktop() {
      return this.windowWidth >= 992;
    },
    getVisualHeight() {
      let height = this.visualViewportHeight;
      if (this._isDesktop && this.$route.query.type === "live") {
        height -= 100;
      }
      return height;
    }
  },
  data() {
    return {
      windowWidth: window.innerWidth,
      visualViewportHeight: window.visualViewport
        ? window.visualViewport.height
        : window.innerHeight
    };
  },
  mounted() {
    window.addEventListener("resize", () => {
      this.windowWidth = window.innerWidth;
    });

    if (window.visualViewport) {
      window.visualViewport.addEventListener("scroll", this.viewportHandler);
      window.visualViewport.addEventListener("resize", this.viewportHandler);
    } else {
      window.addEventListener("resize", this.viewportHandler);
    }
  },

  methods: {
    viewportHandler() {
      this.visualViewportHeight = window.visualViewport
        ? window.visualViewport.height
        : window.innerHeight;
    }
  }
});
